import { createBrowserHistory } from 'history'
import { applyMiddleware, compose, createStore } from 'redux'
import { routerMiddleware } from 'connected-react-router'
import createRootReducer from './reducers'
import thunk from 'redux-thunk'

export const history = createBrowserHistory()

const initialState = {}
const enhancers = []
const middleware = [thunk, routerMiddleware(history)]

if (process.env.NODE_ENV !== 'production') {
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension())
  }
}

const composedEnhancers = compose(
  applyMiddleware(...middleware),
  ...enhancers,
)

export default function configureStore(preloadedState) {
  const store = createStore(
    createRootReducer(history),
    initialState,
    composedEnhancers,
  )

  return store
}

export const createStoreForTesting = (state = initialState) =>
  createStore(createRootReducer(history), state, composedEnhancers)



// WEBPACK FOOTER //
// ./src/redux/configureStore.js